export interface WalletAccount {
  address: string;
  // Raw chain ID from AppKit (stringified) - can be string or number for wallet compatibility
  chainId: string | number;
  /**
   * CAIP-2 format chain identifier (e.g., "eip155:1", "solana:5eykt4UsFv8P8JJd4ESu47Z26wfmJSqeLZyqLdqyHi2K")
   * This is mapped from AppKit's `caipNetworkId` property and is used throughout the application
   * for SDK calls and chain identification.
   *
   * Note: AppKit uses `caipNetworkId` in its types, but we use `caip2ChainId` internally
   * for consistency with our codebase naming conventions.
   */
  caip2ChainId: string;
  namespace: string;
  name?: string;
  balance?: string;
  logoUrl?: string;
}

export enum WalletAdapterStatus {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  ERROR = "error",
}

export interface TransactionRequest {
  to: string;
  value?: string;
  data?: string;
  chainId?: string | number;
}

export interface TransactionResponse {
  hash: string;
  chainId: string | number;
}
